const TypeEvent = {
  LIVE: 0,
  LIVESHOW: 1,
  VOD: 2,
  CATEGORY: 3,
  LEAGUE: 4,
  STORY: 5,
  BANNER: 6,
  CHANNEL: 7,
  SHORT: 8
}
export default TypeEvent
